const round2DecimalPlaces = (val: number) => Math.floor(val * 100) / 100;
export function formatNumber(value: number): string {
  if (value === undefined || value === null) return '0';

  const absValue = Math.abs(value);
  const sign = value < 0 ? '-' : '';

  // Scale to K/M/B (rounded down to 2 decimals)
  if (absValue >= 1000000000) {
    return `${sign}${round2DecimalPlaces(value / 1000000000)}B`;
  }
  if (absValue >= 1000000) {
    return `${sign}${round2DecimalPlaces(value / 1000000)}M`;
  }
  if (absValue >= 1000) {
    return `${sign}${round2DecimalPlaces(value / 1000)}K`;
  }

  // Use Intl for comma-separated thousands formatting on smaller numbers
  return new Intl.NumberFormat('en-US').format(value);
}
export const InternationalNumberFormatter = Intl.NumberFormat('en-US');
